import EventsAPI from '../api/events-api';
import Utility from './utility';

class Events {
    eventContainers: NodeListOf<HTMLElement>;

    constructor() {
        this.init();
    }

    init() {
        let self = this;
        // START: <events-container>
        class EventsContainerElement extends HTMLDivElement {
            constructor() { super(); }
        }
        customElements.define('events-container', EventsContainerElement, { extends: 'div' });
        // END: <events-container>

        // START: <event-filters>
        class EventFilterElement extends HTMLUListElement {
            constructor() { super(); }
        }
        customElements.define('event-filters', EventFilterElement, { extends: 'ul' });
        // END: <event-filters>

        this.eventContainers = document.querySelectorAll("events-container");
        if (this.eventContainers) {
            this.eventContainers.forEach(function(eventContainer: HTMLElement) {
                let limit = Number(eventContainer.dataset.limit);
                let displayType = eventContainer.dataset.type;
                let infiniteScroll = eventContainer.dataset.infinite;
                let id = eventContainer.id;
                let eventAPI = new EventsAPI(eventContainer, displayType);
                // console.log('Found Fillers');
                // console.log(`.${id}-filters`);
                // console.log(eventFilters);
                // console.log(eventFilterSelects);

                if (infiniteScroll == "yes") {
                    const sentinel = document.createElement('div');
                    sentinel.classList.add('event-senti');
                    eventContainer.parentElement.appendChild(sentinel);
                    eventContainer.dataset.page = "0";
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting)
                            {
                                // call more
                                let page = parseInt(eventContainer.dataset.page);
                                if (eventContainer.dataset.maxPages) {
                                    let maxPages = parseInt(eventContainer.dataset.maxPages)
                                    if (page < maxPages) {
                                        page = page + 1;
                                        eventContainer.dataset.page = page.toString();
                                        eventAPI.get(limit, page);
                                    }
                                }
                            }
                        });
                    });
                    observer.observe(sentinel);
                }

                var filterCounter = 0;
                if (id) {
                    let eventFilters = document.querySelector(`.${id}-filters`);
                    if (eventFilters) {
                        // support landing page select/option filters
                        let eventFilterSelects = eventFilters.querySelectorAll('select') as NodeListOf<HTMLSelectElement>;
                        if (eventFilterSelects) {
                            eventFilterSelects.forEach(function(filter) {
                                filter.id = `efilter-${filterCounter}`;
                                filter.dataset.position = filterCounter.toString();
                                filterCounter++;
                                filter.addEventListener('change', function() {
                                    eventAPI.addFilter(this.id, this.value);
                                    Utility.setUrlParameter(this.id, this.value);
                                    eventContainer.innerHTML = "";
                                    eventContainer.dataset.page = "0";
                                    eventAPI.get(limit);
                                });

                                let filterValue = Utility.getUrlParameter(filter.id);
                                if (filterValue && filterValue != "") {
                                    filter.value = filterValue;
                                    eventAPI.addFilter(filter.id, filter.value);
                                }
                            });
                        }
                    } else {
                        // support inline filters
                        let filters = eventContainer.dataset.filters;
                        filters.split(',').forEach((value) => {
                            eventAPI.filters.push({
                                name: value,
                                value: value
                            });
                        });
                    }
                }
                // get events
                eventAPI.get(limit);
            });
        }
    }
}
export default Events;